
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import { Loading } from "element-ui";
import router from './router';
import util from "@/utils/util"
Vue.prototype.$util = util;

Vue.prototype.$Loading = Loading;


Vue.use(ElementUI);
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})